export default function Element$firstNode () {
	return this.node;
}
